import axios from "./axios";

export const campusService = () =>
  axios.get(`${process.env.REACT_APP_API_URL + "api/campus"}`);

export const countryService = () =>
  axios.get(`${process.env.REACT_APP_API_URL + "api/country"}`);

export interface IStudentService {
  campus: string;
  sid: string;
  country: string;
  phone: string;
}

export const studentService = (student: IStudentService) =>
  axios.post(`${process.env.REACT_APP_API_URL + "api/student/"}`, student);

export const loginService = (student: FormData) =>
  axios({
    method: "post",
    url: `${process.env.REACT_APP_API_URL + "app/login/"}`,
    data: student,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const verifyService = (
  id: string,
  secret: string,
  country: string,
  phone: string
) =>
  axios.get(
    `${process.env.REACT_APP_API_URL}app/verify/${id}/${secret}/${country}/${phone}/`
  );

export const authService = (student: FormData) =>
  axios({
    method: "post",
    url: `${process.env.REACT_APP_API_URL + "app/auth/"}`,
    data: student,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const AttendanceService = (secret: string) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}academics/attendance/${secret}`
  );
};
